<mg-table [collectionComponent]="this" matSort stickyHeaders>

    <ng-container matColumnDef="projectregel">
        <th mat-header-cell *matHeaderCellDef mat-sort-header> Projectregel </th>
        <td mat-cell *matCellDef="let row"> {{row.pakbonregel.projectregel.certificaatId}} </td>
    </ng-container>

	<ng-container matColumnDef="barcode">
        <th mat-header-cell *matHeaderCellDef mat-sort-header> Barcode </th>
        <td mat-cell *matCellDef="let row"> {{row.pakbonregel.projectregel.instrument.nr_Barcode}} </td>
    </ng-container>

    <ng-container matColumnDef="soort">
        <th mat-header-cell *matHeaderCellDef mat-sort-header> Soort </th>
        <td style="max-width: 15em;" mat-cell *matCellDef="let row"> {{row.pakbonregel.projectregel.instrument.soort}} </td>
    </ng-container>

    <ng-container matColumnDef="type">
        <th mat-header-cell *matHeaderCellDef mat-sort-header> Type </th>
        <td style="max-width: 15em;" mat-cell *matCellDef="let row"> {{row.pakbonregel.projectregel.instrument.type}} </td>
    </ng-container>
    
    <ng-container matColumnDef="omschrijving">
        <th mat-header-cell *matHeaderCellDef mat-sort-header> Omschrijving </th>
        <td style="max-width: 15em;" mat-cell *matCellDef="let row"> {{row.omschrijving}} </td>
    </ng-container>
    
    <ng-container matColumnDef="aantal">
        <th mat-header-cell *matHeaderCellDef mat-sort-header> Aantal </th>
        <td mat-cell *matCellDef="let row"> {{row.aantal.toFixed(2)}} </td>
    </ng-container>

    <ng-container matColumnDef="prijs">
        <th mat-header-cell *matHeaderCellDef mat-sort-header pd-size-6> Prijs (ex) </th>
        <td mat-cell *matCellDef="let row"> € {{row.prijs.toFixed(2)}} </td>
    </ng-container>

    <ng-container matColumnDef="regelprijs">
        <th mat-header-cell *matHeaderCellDef mat-sort-header pd-size-6> Prijs </th>
        <td mat-cell *matCellDef="let row"> € {{ row.pakbonregel.projectregel.prijsBlock == true ? "0.00" : row.regelprijs.toFixed(2)}} </td>
    </ng-container>
    
    <ng-container matColumnDef="korting">
        <th mat-header-cell *matHeaderCellDef mat-sort-header pd-size-4> Korting </th>
        <td mat-cell *matCellDef="let row" style="text-align: right;"> {{row.korting}} %</td>
    </ng-container>

    <ng-container matColumnDef="goedgekeurdOp">
        <th mat-header-cell *matHeaderCellDef mat-sort-header> goedgekeurd Op </th>
        <td mat-cell *matCellDef="let row" style="text-align: right;"> {{row.goedgekeurdOp}}</td>
    </ng-container>

</mg-table>
